/**
 * Scanner API (/api/v1/scanner)
 *
 * Note on count modes (INVENTORY_COUNT / CYCLE_COUNT): the backend records
 * the counted quantity as an observation (lastCountQty); quantityOnHand is
 * only changed when the count is reconciled in the inventory domain.
 */

import { apiPost } from "./client";
import { ScanRequest, ScanResult } from "./types";

export function submitScan(request: ScanRequest): Promise<ScanResult> {
  return apiPost<ScanResult>("/scanner/scan", request);
}
